export default {
  stage: REPLACE_STAGE || 'dev',
}
